module.exports = __webpack_public_path__ + "img/anniu2.a68b15ee.png";